// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"58":"5454bdb4","312":"8b6b3fd2","355":"016a108d","371":"6944d42d","376":"379cf4bf","436":"978fa61c","588":"635eb68a"}[chunkId] + ".chunk.js";
};